import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-menu',
  templateUrl: './about-menu.component.html',
  styleUrls: ['./about-menu.component.scss']
})
export class AboutMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
